module.exports = __webpack_public_path__ + "media/images/sp/brands/common/main-visual-text-98ba2e1a47686d32fadb10afa3e731dc.svg";